const getRecipeConsumptionSource = (item) => {
  if (Array.isArray(item?.consumos)) {
    return item.consumos;
  }

  if (Array.isArray(item?.stockConsumptions)) {
    return item.stockConsumptions;
  }

  if (Array.isArray(item?.stock_consumptions)) {
    return item.stock_consumptions;
  }

  return [];
};

const normalizeRecipeIngredientName = (consumption) =>
  String(
    consumption?.ingredientName ||
      consumption?.ingredient_name ||
      consumption?.name ||
      consumption?.nombre ||
      "Ingrediente"
  )
    .trim()
    .replace(/\s+/g, " ") || "Ingrediente";

const normalizeRecipeIngredientUnit = (consumption) =>
  String(
    consumption?.unit ||
      consumption?.unidad ||
      consumption?.consumptionUnit ||
      consumption?.consumption_unit ||
      "un"
  )
    .trim()
    .toLowerCase() || "un";

export const getKitchenRecipeIngredients = (item) => {
  const ingredientsByKey = new Map();

  getRecipeConsumptionSource(item).forEach((consumption) => {
    const quantity = Number(consumption?.quantity ?? consumption?.cantidad ?? 0);

    if (!Number.isFinite(quantity) || quantity <= 0) {
      return;
    }

    const id = String(
      consumption?.ingredientId || consumption?.ingredient_id || consumption?.id || ""
    ).trim();
    const name = normalizeRecipeIngredientName(consumption);
    const unit = normalizeRecipeIngredientUnit(consumption);
    const key = `${id || name.toLowerCase()}::${unit}`;
    const previous = ingredientsByKey.get(key);

    ingredientsByKey.set(key, {
      id: id || key,
      name,
      unit,
      quantity: Number(((previous?.quantity || 0) + quantity).toFixed(4)),
    });
  });

  return Array.from(ingredientsByKey.values());
};

export const formatKitchenRecipeQuantity = (value) =>
  new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(Number(value || 0));
